const DataShop = [
    {
        colors: [
            'Matt White',
            'Dulux Woodland Grey'
        ],
        description : 'This slick range of glass reinforced cylinders is finished with a crisp white polymer coating for a modern take on the traditional planter. The contemporary cylinder range is lightweight and suitable for both indoors and out.',
        image : 'images/shop/contemporary-range-grey.jpg',
        images : [
            '../images/shop/contemporary-grey-400.jpg',
            '../images/shop/contemporary-white-400.jpg',
            '../images/shop/contemporary-grey-500',
            '../images/shop/contemporary-white-500.jpg',
            '../images/shop/contemporary-grey-650.jpg',
            '../images/shop/contemporary-white-650.jpg',
            '../images/shop/contemporary-grey-800.jpg',
            '../images/shop/contemporary-white-800.jpg'
        ],
        price : '$170.00',
        sizes : [
            'Small (400mm dia x 450mm height)',
            'Medium (500mm dia x 450mm height)',
            'Large (650mm dia x 550mm height)',
            'X-Large (800mm dia x 680mm height)'
        ],
        title : 'Contemporary Cylinder',
        url : '/shop/contemporary-cylinder',

    },
    {
        colors : [
            'Matt White',
            'Dulux Woodland Grey'
        ],
        description : 'This slick range of glass reinforced cylinders is finished with a crisp white polymer coating for a modern take on the traditional planter. The contemporary cylinder range is lightweight and suitable for both indoors and out.',
        image : 'images/shop/low-cylinder-white-group.jpg',
        images : [
            '../images/shop/low-cylinder-grey-group.jpg',
            '../images/shop/low-cylinder-white-group.jpg',
            '../images/shop/low-cylinder-grey-650.jpg',
            '../images/shop/low-cylinder-white-650.jpg',
            '../images/shop/low-cylinder-grey-800.jpg',
            '../images/shop/low-cylinder-white-800.jpg'
        ],
        price : '$265.00',
        sizes : [
            'Medium (650mm dia x 300mm height)',
            'Large (800mm dia x 400mm height)' 
        ],
        title : 'Low Cyclindar',
        url : '/shop/low-cylinder',
    },
    {
        colors : [
            'Matt White',
            'Dulux Woodland Grey'
        ],
        description : 'This slick range of glass reinforced cylinders is finished with a crisp white polymer coating for a modern take on the traditional planter. The Tall cylinder range is lightweight and suitable for both indoors and out.',
        image : 'images/shop/tall-cylinders-grey-group.jpg',
        images : [
            '../images/shop/tall-cylinders-grey-group.jpg',
            '../images/shop/tall-cylinders-white-group.jpg',
            '../images/shop/tall-cylinders-grey-360.jpg',
            '../images/shop/tall-cylinders-white-360.jpg',
            '../images/shop/tall-cylinders-grey-450.jpg',
            '../images/shop/tall-cylinders-white-450.jpg'
        ],
        price : '$265.00',
        sizes : [
            'Medium (360mm dia x 650mm height)',
            'Large (450mm dia x 850mm height)'
        ] ,
        title : 'Tall Cyclinder',
        url : '/shop/tall-cylindar',
    },
    {
        colors : [
            'Matt White',
            'Dulux Woodland Grey'
        ],
        description : 'This slick range of glass reinforced cylinders is finished with a crisp white polymer coating for a modern take on the traditional planter. The cylinder range is lightweight and suitable for both indoors and out.',
        image : 'images/shop/bullet-bowl-white-group.jpg',
        images : [
            '../images/shop/bullet-bowl-grey-group.jpg',
            '../images/shop/bullet-bowl-white-group.jpg',
            '../images/shop/bullet-bowl-grey-720.jpg',
            '../images/shop/bullet-bowl-white-720.jpg',
            '../images/shop/bullet-bowl-grey-960.jpg',
            '../images/shop/bullet-bowl-white-960.jpg'
        ],
        price : '$575.00',
        sizes : [
            'Medium (720mm dia x 650mm height)',
            'Large (960mm dia x 750mm height)'
        ],
        title : 'Bullet Bowl',
        url : '/shop/bullet-bowl',
    },
    {
        colors : [
            'Matt White',
            'Dulux Woodland Grey'
        ],
        description : 'This slick range of glass reinforced cylinders is finished with a crisp white polymer coating for a modern take on the traditional planter. The cylinder range is lightweight and suitable for both indoors and out.',
        price : '$250.00',
        image : 'images/shop/shallow-bowl-grey-group.jpg',
        images : [
            '../images/shop/shallow-bowl-grey-group.jpg',
            '../images/shop/shallow-bowl-white-group.jpg',
            '../images/shop/shallow-bowl-grey-650.jpg',
            '../images/shop/shallow-bowl-white-650.jpg',
            '../images/shop/shallow-bowl-grey-800.jpg',
            '../images/shop/shallow-bowl-white-800.jpg'
        ],
        sizes : [
            'Medium (650mm dia x 300mm height)',
            'Large (800mm dia x 400mm height)'
        ],
        title : 'Shallow Bowl',
        url : '/shop/shallow-bowl',
    },
    {
        colors : [
            'Matt White'
        ],
        description : 'This slick range of glass reinforced cylinders is finished with a crisp white polymer coating for a modern take on the traditional planter. The cylinder range is lightweight and suitable for both indoors and out.',
        image : 'images/shop/wine-glass-planter-white-group.jpg',
        images : [
            '../images/shop/wine-glass-planter-white-group.jpg',
            '../images/shop/wine-glass-planter-white-450.jpg',
            '../images/shop/wine-glass-planter-white-600.jpg',
            '../images/shop/wine-glass-planter-white-750.jpg'
        ],
        price : '$275.00',
        sizes : [
            'Small (450mm dia x 560mm height)',
            'Medium (600mm dia x 710mm height)',
            'Large (750mm dia x 890mm height)'
        ],
        title : 'Wine Glass Planter',
        url : '/shop/wine-glass-planter',
    },
]

export default DataShop;